<script>
import resources from './resources'

export default {
  name: 'professional-graduations',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row(style="margin-top: 10px; margin-bottom: 20px;")
    .col-xs-12.col-sm-4.margin-bottom
      small.grey Graduação
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.label }}

    .col-xs-12.col-sm-6.margin-bottom
      small.grey Instituição de Ensino
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.entity }}

    .col-xs-12.col-sm-2.margin-bottom
      small.grey Ano
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.year }}
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/professional/components/graduations/graduations.vue